import { ButtonType } from "@constellation-academy/epic-ui";
import { useFormik } from "formik";
import { useTranslation } from "@i18n/hooks";
import { fieldWrapperClass, wrapperClass } from "./app-build-number-form.styles";
import type {
	AppBuildNumberFormProps,
	AppBuildNumberFormValues,
} from "./app-build-number-form.types";
import { Button } from "../../../../components/button";
import { DefaultTextFieldComponent } from "../../../../components/DefaultTextInput";
import { ValidatedField } from "../../../../components/ValidatedField";

export const AppBuildNumberForm = ({ initialValues, onSubmit }: AppBuildNumberFormProps) => {
	const { t } = useTranslation("common");

	const form = useFormik<AppBuildNumberFormValues>({
		initialValues: initialValues ?? {
			iosBuildNumber: "",
			androidBuildNumber: "",
		},
		onSubmit,
	});

	return (
		<form onSubmit={form.handleSubmit} className={wrapperClass}>
			<div className={fieldWrapperClass}>
				<ValidatedField<AppBuildNumberFormValues, string>
					label={t("appBuildNumber.iosLabel")}
					name="iosBuildNumber"
					component={DefaultTextFieldComponent}
					formikConfig={form}
				/>
				<ValidatedField<AppBuildNumberFormValues, string>
					label={t("appBuildNumber.androidLabel")}
					name="androidBuildNumber"
					component={DefaultTextFieldComponent}
					formikConfig={form}
				/>
			</div>
			<Button type={ButtonType.Submit} label={t("actions.save")} />
		</form>
	);
};
